import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "arrowPlacement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styled, Tooltip, tooltipClasses } from '@mui/material';
import { colors, pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTooltip = styled(function (_ref) {
  var className = _ref.className,
      arrowPlacement = _ref.arrowPlacement,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
    classes: {
      popper: className
    }
  }));
})(function (_ref2) {
  var _styles;

  var theme = _ref2.theme,
      arrowPlacement = _ref2.arrowPlacement;
  var styles = (_styles = {}, _defineProperty(_styles, "& .".concat(tooltipClasses.tooltip), _objectSpread(_objectSpread({}, theme.typography.body3), {}, {
    padding: theme.spacing(1.5),
    backgroundColor: colors.white,
    color: colors.mirage,
    boxShadow: '0px 0px 1.3px rgba(44, 45, 46, 0.25), 0px 20px 13px rgba(52, 56, 67, 0.03), 0px 8px 5px rgba(52, 56, 67, 0.08)'
  })), _defineProperty(_styles, "& .".concat(tooltipClasses.arrow), {
    color: colors.white,
    '&:before': {
      border: "1px solid ".concat(colors.mirage),
      boxShadow: '0px 0px 1.3px rgba(44, 45, 46, 0.25), 0px 20px 13px rgba(52, 56, 67, 0.03), 0px 8px 5px rgba(52, 56, 67, 0.08)'
    }
  }), _styles);

  switch (arrowPlacement) {
    case 'bottom-start':
    case 'top-start':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(".concat(pxToRem(10), ", 0px)!important")
        })));
        break;
      }

    case 'bottom-end':
    case 'top-end':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(".concat(pxToRem(32), ", 0px)!important")
        })));
        break;
      }

    case 'left-start':
    case 'right-start':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(0px, ".concat(pxToRem(6), ")!important")
        })));
        break;
      }

    case 'left-end':
    case 'right-end':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(0px, ".concat(pxToRem(24), ")!important")
        })));
        break;
      }

    default:
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread({}, styles["& .".concat(tooltipClasses.arrow)])));
        break;
      }
  }

  return styles;
});
export { StyledTooltip };